import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from "@mui/material";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import '../../style/SalesMarketing.css';
import * as Yup from 'yup';
import {useNavigate, useParams} from "react-router-dom";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useProductCodeActions} from "../../service/useProductCodeActions";
import {
    LEISURE_AGREEMENT_STATUS_DISMISSED,
    LEISURE_AGREEMENT_STATUS_DRAFT,
    LEISURE_AGREEMENT_STATUS_READY
} from "../../component/Constants";
import {Controller, useFieldArray, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {DeleteRounded, DoDisturbAltRounded, LibraryAddRounded} from "@mui/icons-material";
import {IconButton} from "@mui/material/";
import EmptyState from "../../../../util/component/EmptyState";
import AddProductModal from "../businessAgreement/modals/AddProductModal";
import {useStatusValuesProduct} from "../../component/useStatusValuesProduct";
import {useLookupActions} from "../../service/useLookupActions";
import AsyncAutocomplete from "../../component/AsyncAutocomplete";
import {useCustomerBaseActions} from "../../service/useCustomerBaseActions";
import {useLeisureAgreementActions} from "../../service/useLeisureAgreementActions";
import {useStatusValuesLeisureAgreement} from "../../component/useStatusValuesLeisureAgreement";
import LeisureAgreementCreationModal from "./modals/LeisureAgreementCreationModal";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {
    preselectSingleEntity,
    UserLegalEntitiesOrDealersInputGroup
} from "../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import { handleChangeCustomer } from "../../component/Utils";
import {CATEGORY_LIST} from "../../service/SalesMarketingRecoil";
import {useRecoilValue} from "recoil";

interface LeisureAgreementDetail {
    id: number,
    status: string,
    name: string,
    description: string,
    segmentCode: string,
    startDate: Date,
    endDate: Date,
    customerId: string,
    customerName: string,
    leisureCode: string,
    productList: any[],
    tenantId: string,
    dealerId:string
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const LeisureAgreementCreateOrUpdatePage = () => {
    const {leisureAgreementId} = useParams();
    const isUpdate = !!leisureAgreementId;
    const {t} = useTranslation(['salesmarketing', 'translation']);
    const navigate = useNavigate();
    const [leisureAgreement, setLeisureAgreement] = useState<LeisureAgreementDetail>();
    const productCodeActions = useProductCodeActions();
    const [selectedCustomer, setSelectedCustomer] = useState<any>("");
    const [openAddProductModal, setOpenAddProductModal] = useState(false);
    const [segments, setSegments] = useState<any[]>([]);
    const [categories, setCategories] = useState<any[]>([]);
    const {getDetailAgreement, createAgreement, updateAgreement, getProductActiveCount} = useLeisureAgreementActions();
    const {getCustomerList} = useCustomerBaseActions();
    const {globalData, dispatchGlobalData} = useContext(GlobalContext);
    const categoriesMap = useRecoilValue(CATEGORY_LIST);

    const getCategoryLabelByCode = (code: string, tenantId: string) => {
        if (!code || !tenantId || !categoriesMap[tenantId]) {
            return code;
        }
        const tenantCategories = categoriesMap[tenantId];
        const category = tenantCategories.find(cat => cat.categoryCode === code);
        return category ? category.categoryLabel : code;
    }

    const {getStatusLabelAgreement} = useStatusValuesLeisureAgreement();
    const {getStatusColorProduct, getStatusLabelProduct} = useStatusValuesProduct();

    const [openCreationModal, setOpenCreationModal] = useState(false);
    const [newLeisureCode, setNewLeisureCode] = useState("");
    const statuses = [
        {
            key: LEISURE_AGREEMENT_STATUS_DRAFT,
            value: getStatusLabelAgreement(LEISURE_AGREEMENT_STATUS_DRAFT)
        },
        {
            key: LEISURE_AGREEMENT_STATUS_READY,
            value: getStatusLabelAgreement(LEISURE_AGREEMENT_STATUS_READY)
        },
        {
            key: LEISURE_AGREEMENT_STATUS_DISMISSED,
            value: getStatusLabelAgreement(LEISURE_AGREEMENT_STATUS_DISMISSED)
        }
    ]

    useEffect(() => {
        // Retrieve data
        productCodeActions.listSegment().then(resp => {
            setSegments(resp);
        })
        if (leisureAgreementId && isUpdate) {
            // retrieve leisure agreement
            getDetailAgreement(leisureAgreementId).then(res => {
                if (res.customerId && res.customerName) {
                    setSelectedCustomer({value: res.customerId, label: res.customerName});
                }
                setLeisureAgreement(res);
            })
        }
    }, []);

    useEffect(() => {
        reset(retrieveInitialValues())
    },[leisureAgreement])

    const retrieveInitialValues = () => {
        if (isUpdate && leisureAgreement) {
            return {
                tenantId:leisureAgreement.tenantId ? leisureAgreement.tenantId : "",
                dealerId: leisureAgreement.dealerId ? leisureAgreement.dealerId : "",
                id: leisureAgreement.id ? leisureAgreement.id : null,
                status: leisureAgreement.status ? leisureAgreement.status : "",
                name: leisureAgreement.name ? leisureAgreement.name : "",
                description: leisureAgreement.description ? leisureAgreement.description : "",
                segmentCode: leisureAgreement.segmentCode ? leisureAgreement.segmentCode : "",
                startDate: leisureAgreement.startDate ? leisureAgreement.startDate : null,
                endDate: leisureAgreement.endDate ? leisureAgreement.endDate : null,
                customerId: leisureAgreement.customerId ? leisureAgreement.customerId : "",
                customerName: leisureAgreement.customerName ? leisureAgreement.customerName : "",
                leisureCode: leisureAgreement.leisureCode ? leisureAgreement.leisureCode : "L",
                productList: leisureAgreement.productList ? leisureAgreement.productList : []
            };
        } else {
            return {
                tenantId : '',
                dealerId: '',
                status: "",
                name: "",
                description: "",
                segmentCode: "",
                startDate: null,
                endDate: null,
                customerId: "",
                customerName: "",
                leisureCode: "L",
                productList: []
            };
        }
    }

    const validationSchema = Yup.object({
        tenantId: Yup.string().nullable().test('testTenant', t('salesmarketing:leisureAgreement.createForm.requiredCheck'),(value)=>{
            if(globalData?.user?.legalEntities?.length ===1)
                return true;
            return !!value;
        }),
        dealerId:Yup.string().nullable().test('testDealer', t('salesmarketing:leisureAgreement.createForm.requiredCheck'),(value)=>{
            if(globalData?.user?.dealers?.length ===1)
                return true;
            return !!value;
        }),
        status: Yup.string().required(t('salesmarketing:leisureAgreement.createForm.requiredCheck')),
        name: Yup.string().required(t('salesmarketing:leisureAgreement.createForm.requiredCheck')),
        description: Yup.string().nullable(),
        segmentCode: Yup.string().required(t('salesmarketing:leisureAgreement.createForm.requiredCheck')),
        productList: Yup.array().nullable(),
        customerId: Yup.string().required(t('salesmarketing:leisureAgreement.createForm.requiredCheck')),
        customerName:Yup.string().required(t('salesmarketing:leisureAgreement.createForm.requiredCheck')),
        leisureCode: Yup.string()
            .required(t('salesmarketing:leisureAgreement.createForm.requiredCheck'))
            .test(
                'leisureCheck',
                t('salesmarketing:leisureAgreement.errors.leisureCodeFormat'),
                (value) => {
                    if (isUpdate) return true;
                    const regex = /^L[a-zA-Z0-9]{8}$/;
                    return value ? regex.test(value) : false;
                }
            ),

        startDate: Yup.date().required(t('salesmarketing:leisureAgreement.createForm.requiredCheck'))
            .test("testBookingStartDate", t('salesmarketing:leisureAgreement.createForm.dateRangeCheck'), (value, context) => {
                return (value && context.parent.endDate && value <= context.parent.endDate)
            }).typeError(t('salesmarketing:leisureAgreement.createForm.invalidDateCheck')),
        endDate: Yup.date().required(t('salesmarketing:leisureAgreement.createForm.requiredCheck'))
            .test("testBookingEndDate", t('salesmarketing:leisureAgreement.createForm.dateRangeCheck'), (value, context) => {
                return (value && context.parent.startDate && value >= context.parent.startDate)
            }).typeError(t('salesmarketing:leisureAgreement.createForm.invalidDateCheck')),
    });

    const {handleSubmit, control, setValue, watch, reset,trigger,formState} = useForm({
        defaultValues: retrieveInitialValues(),
        resolver: yupResolver(validationSchema)
    });

    useEffect(() => {
        const tenantId = watch("tenantId");
        if (tenantId) {
            productCodeActions.listCategory(tenantId);
        }
    }, [watch("tenantId")]);

    useEffect(() => {
        const selectedSegment = watch("segmentCode");
        const tenantId = watch("tenantId");
        const tenantCategories = categoriesMap[tenantId] || [];

        if (selectedSegment) {
            setCategories(
                tenantCategories.filter(cat => cat.segmentCode === selectedSegment)
            );
        } else {
            setCategories([]);
        }
    }, [watch("segmentCode"), watch("tenantId"), categoriesMap]);

    

    const onSubmit = async (values: any) => {
        if (checkList()) {
            let payload = {...values};
            payload.customerName = selectedCustomer?.label;
            if (isUpdate) {
                let data = await updateAgreement(payload);
                if (data && data.status === 'OK') {
                    // show modal with confirm
                    setOpenCreationModal(true);
                } else if(data.code ===10){
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t(`leisureAgreement.errors.used`),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                }
            } else {
                if (globalData.user.legalEntities.length === 1) {
                    payload = {...payload, tenantId: globalData.user.legalEntities[0].name}
                }

                if (globalData.user.dealers.length === 1) {
                    payload = {...payload, dealerId: globalData.user.dealers[0].name}
                }
                let data = await createAgreement(payload);
                if (data && data.status === 'OK') {
                    // show modal with confirm
                    setNewLeisureCode(data.result?.leisureCode);
                    setOpenCreationModal(true);
                } else if(data.code ===10){
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t(`leisureAgreement.errors.used`),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                }
            }
        }
    }

    function checkList() {
        let result = {isOk: true};

        return result.isOk;
    }

    const { fields, append, remove } = useFieldArray({
        control,
        name: "productList"
    });

    /**
     * Stato del flusso di rimozione prodotto dalla lista (LPP-20956).
     * - 'idle': nessuna interazione in corso.
     * - 'blocked': product code in uso da N booking attive, rimozione bloccata.
     * - 'confirm': product code non utilizzato, chiediamo conferma all'utente.
     */
    const [removeProductDialog, setRemoveProductDialog] = useState<{
        state: 'idle' | 'blocked' | 'confirm',
        index: number,
        productCode: string,
        leisureCode: string,
        activeCount: number
    }>({state: 'idle', index: -1, productCode: '', leisureCode: '', activeCount: 0});

    const closeRemoveProductDialog = () => {
        setRemoveProductDialog({state: 'idle', index: -1, productCode: '', leisureCode: '', activeCount: 0});
    };

    /**
     * Click sul cestino di una riga della Lista Prodotti.
     *
     * In creazione (no leisureCode persistito) la riga non può aver
     * generato booking, rimuoviamo direttamente.
     *
     * In update interroghiamo il BFF per sapere se ci sono booking attive
     * legate al binomio productCode + leisureCode su questo tenant/dealer.
     * Se sì blocchiamo, altrimenti chiediamo conferma.
     */
    const handleRequestRemoveProduct = async (index: number, row: any) => {
        const productCode = row?.productCode;
        const leisureCode = watch("leisureCode");
        const tenantId = watch("tenantId");
        const dealerId = watch("dealerId");

        if (!isUpdate || !productCode || !leisureCode || !tenantId || !dealerId) {
            // creazione, oppure dati incompleti: niente check, rimozione diretta
            remove(index);
            return;
        }

        const activeCount = await getProductActiveCount(productCode, leisureCode, tenantId, dealerId);
        if (activeCount > 0) {
            setRemoveProductDialog({state: 'blocked', index, productCode, leisureCode, activeCount});
        } else {
            setRemoveProductDialog({state: 'confirm', index, productCode, leisureCode, activeCount: 0});
        }
    };

    const confirmRemoveProduct = () => {
        if (removeProductDialog.state === 'confirm' && removeProductDialog.index >= 0) {
            remove(removeProductDialog.index);
        }
        closeRemoveProductDialog();
    };

    useEffect(() => {
        preselectSingleEntity(globalData, setValue);
    }, [globalData, setValue]);

    return (
        <>
            <SectionHeader
                title={t(isUpdate ? 'salesmarketing:leisureAgreement.updateHeader.title' : 'salesmarketing:leisureAgreement.createHeader.title')}
                subtitle={t('salesmarketing:leisureAgreement.createHeader.subTitle')}/>
            <Paper elevation={3} sx={{padding: "16px", margin: "18px"}}>
                <form onSubmit={handleSubmit(data => {
                    onSubmit(data);
                }, errors => console.log(errors))} noValidate>
                    <Grid container rowSpacing={3} columnSpacing={3}>
                        <UserLegalEntitiesOrDealersInputGroup control={control} disabled={isUpdate}/>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"leisureCode"}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        fullWidth
                                        label={t('salesmarketing:leisureAgreement.leisureCode')}
                                        disabled={isUpdate}
                                        value={field.value}
                                        onChange={(e)=>{
                                            if(e.target.value.length <=9)
                                                field.onChange( e.target.value.charAt(0) ==='L' ? e.target.value :'L' + e.target.value);
                                        }}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )} />
                        </Grid>
                        <Grid item xs={9}/>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"status"}
                                render={({field, fieldState}) => (
                                    <TextField
                                        fullWidth
                                        required
                                        name="status"
                                        label={t('salesmarketing:leisureAgreement.status')}
                                        select
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    >
                                        <MenuItem key={""} value={""}/>
                                        {statuses?.map((a) => (
                                            <MenuItem key={a.key} value={a.key}>
                                                {a.value}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"segmentCode"}
                                render={({field, fieldState}) => (
                                    <TextField
                                        fullWidth
                                        disabled={watch("productList").length > 0 || watch("tenantId") === "" || watch("dealerId") === ""}
                                        required
                                        name="segmentCode"
                                        label={t('salesmarketing:leisureAgreement.segment')}
                                        select
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    >
                                        <MenuItem key={""} value={""}/>
                                        {segments?.map((a) => (
                                            <MenuItem key={a.segmentCode} value={a.segmentCode}>
                                                {a.segmentName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}/>
                        </Grid>
                        <Grid item xs={6}>
                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                                control={control}
                                name={"customerName"}
                                render={({field, fieldState}) => (
                                    <AsyncAutocomplete id={"customerName"}
                                        value={selectedCustomer}
                                        callback={getCustomerList}
                                        onChange={(value) => {
                                            handleChangeCustomer(value,setSelectedCustomer,setValue,trigger,formState)
                                            field.onChange(value ? value.label : "")
                                        }}
                                        renderInput={(params) => <TextField
                                            {...params}
                                            required
                                            label={t('salesmarketing:leisureAgreement.customerName')}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                        />}
                            />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"customerId"}
                                render={({field, fieldState}) => (
                                    <TextField
                                        fullWidth
                                        required
                                        disabled
                                        name="customerId"
                                        label={t('salesmarketing:leisureAgreement.customerId')}
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"name"}
                                render={({field, fieldState}) => (
                                    <TextField
                                        fullWidth
                                        required
                                        name="name"
                                        label={t('salesmarketing:leisureAgreement.name')}
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                        inputProps={{ maxLength: 30 }}
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"description"}
                                render={({field, fieldState}) => (
                                    <TextField
                                        fullWidth
                                        name="description"
                                        label={t('salesmarketing:leisureAgreement.description')}
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                        inputProps={{ maxLength: 120 }}
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"startDate"}
                                render={({field, fieldState}) => (
                                    <DatePicker
                                        label={t('salesmarketing:leisureAgreement.startDate')}
                                        value={field.value}
                                        onChange={field.onChange}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                required
                                                fullWidth
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}/>
                                        }
                                        inputFormat={"L"}
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"endDate"}
                                render={({field, fieldState}) => (
                                    <DatePicker
                                        label={t('salesmarketing:leisureAgreement.endDate')}
                                        value={field.value}
                                        onChange={field.onChange}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                required
                                                fullWidth
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}/>
                                        }
                                        inputFormat={"L"}
                                    />
                                )}/>
                        </Grid>
                    </Grid>
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid item>
                            <Typography>{t('salesmarketing:leisureAgreement.products.title')}</Typography>
                        </Grid>
                        <Grid item container alignItems={"center"}>
                            <Grid item xs={12}>
                                <Button
                                    sx={{float: "right"}}
                                    disabled={categories.length === 0}
                                    variant={"text"} color={"accent"}
                                    endIcon={<LibraryAddRounded/>} onClick={() => setOpenAddProductModal(true)}>
                                    {t('salesmarketing:leisureAgreement.products.addProduct')}
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            {fields.length === 0 ?
                                <EmptyState icon={<DoDisturbAltRounded/>} title={t('salesmarketing:leisureAgreement.products.noValuesTitle')}
                                            content={t('salesmarketing:leisureAgreement.products.noValuesContent')}/>
                                :
                                <TableContainer>
                                    <Table aria-label="productList-table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>{t('salesmarketing:leisureAgreement.products.name')}</TableCell>
                                                <TableCell>{t('salesmarketing:leisureAgreement.products.code')}</TableCell>
                                                <TableCell>{t('salesmarketing:leisureAgreement.products.startDate')}</TableCell>
                                                <TableCell>{t('salesmarketing:leisureAgreement.products.endDate')}</TableCell>
                                                <TableCell>{t('salesmarketing:leisureAgreement.products.category')}</TableCell>
                                                <TableCell align={"center"}>{t('salesmarketing:leisureAgreement.products.status')}</TableCell>
                                                <TableCell align={"center"}>{t('salesmarketing:leisureAgreement.products.delete')}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {fields.map((row: any, index: number) => (
                                                <TableRow key={row.id}>
                                                    <TableCell>{row.productName ? row.productName : ""}</TableCell>
                                                    <TableCell>{row.productCode ? row.productCode : ""}</TableCell>
                                                    <TableCell>{row.startDate ? dayjs(row.startDate).format("L") : ""}</TableCell>
                                                    <TableCell>{row.endDate ? dayjs(row.endDate).format("L") : ""}</TableCell>
                                                    <TableCell>{row.category ? getCategoryLabelByCode(row.category, watch("tenantId")) : ""}</TableCell>
                                                    <TableCell align={"center"}>{row.status ?
                                                        <Chip label={getStatusLabelProduct(row.status)}
                                                              sx={{backgroundColor: getStatusColorProduct(row.status)}}/>
                                                        : ""}
                                                    </TableCell>
                                                    <TableCell align={"center"}>
                                                        <IconButton
                                                            color={"accent"}
                                                            aria-label="delete"
                                                            onClick={() => handleRequestRemoveProduct(index, row)}
                                                        >
                                                            <DeleteRounded/>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }
                            </Grid>
                    </Grid>
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3} justifyContent={"flex-end"}>
                            <Grid item>
                                <Button variant={"outlined"} color={"accent"}
                                        onClick={() => {
                                            navigate("/salesmarketing/leisureagreementlist")
                                        }}>
                                    {t('salesmarketing:leisureAgreement.buttons.cancel')}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button color={"accent"}
                                        type="submit">{t('salesmarketing:leisureAgreement.buttons.confirm')}</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            <LeisureAgreementCreationModal isUpdate={isUpdate} open={openCreationModal}
                                            handleCloseCreationModal={() => setOpenCreationModal(false)} leisureCode={newLeisureCode}/>
            {openAddProductModal && <AddProductModal tenantId={watch("tenantId")} dealerId={watch("dealerId")} filterProducts={true} open={openAddProductModal} handleClose={() => setOpenAddProductModal(false)} categories={categories} append={append} fields={fields}/>}

            {/* Dialog di blocco rimozione prodotto: ci sono booking attive collegate (LPP-20956). */}
            <Dialog open={removeProductDialog.state === 'blocked'} onClose={closeRemoveProductDialog} maxWidth={"sm"} fullWidth>
                <DialogTitle>{t('salesmarketing:leisureAgreement.products.removeBlockedTitle')}</DialogTitle>
                <DialogContent>
                    <Typography>
                        {t('salesmarketing:leisureAgreement.products.removeBlockedBody', {
                            productCode: removeProductDialog.productCode,
                            leisureCode: removeProductDialog.leisureCode,
                            count: removeProductDialog.activeCount
                        })}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color={"accent"} onClick={closeRemoveProductDialog}>
                        {t('salesmarketing:leisureAgreement.buttons.close')}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialog di conferma rimozione prodotto: nessuna booking attiva collegata. */}
            <Dialog open={removeProductDialog.state === 'confirm'} onClose={closeRemoveProductDialog} maxWidth={"sm"} fullWidth>
                <DialogTitle>{t('salesmarketing:leisureAgreement.products.removeConfirmTitle')}</DialogTitle>
                <DialogContent>
                    <Typography>
                        {t('salesmarketing:leisureAgreement.products.removeConfirmBody', {
                            productCode: removeProductDialog.productCode
                        })}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant={"outlined"} color={"accent"} onClick={closeRemoveProductDialog}>
                        {t('salesmarketing:leisureAgreement.buttons.cancel')}
                    </Button>
                    <Button color={"accent"} onClick={confirmRemoveProduct}>
                        {t('salesmarketing:leisureAgreement.buttons.confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default LeisureAgreementCreateOrUpdatePage;
